export default "__VITE_ASSET__BFgfnDg6__"